import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../core/services/api.service';
import { Partner, PartnerCategory, PartnerInquiryPayload, PartnerOption } from '../models/partner.model';

@Injectable({
    providedIn: 'root'
})
export class PartnersApiService {
    constructor(private apiService: ApiService) { }

    getPublicPartners(): Observable<Partner[]> {
        return this.apiService.get<{ partners: Partner[] }>(`/partners/public?_=${Date.now()}`).pipe(
            map(res => res.partners || [])
        );
    }

    getPartnerBySlug(slug: string): Observable<Partner> {
        return this.apiService.get<{ partner: Partner }>(`/partners/public/${slug}?_=${Date.now()}`).pipe(
            map(res => res.partner)
        );
    }

    getPublicCategories(): Observable<PartnerCategory[]> {
        return this.apiService.get<{ categories: PartnerCategory[] }>(`/partners/categories/public?_=${Date.now()}`).pipe(
            map(res => res.categories || [])
        );
    }

    submitInquiry(data: PartnerInquiryPayload): Observable<any> {
        return this.apiService.post('/partners/inquiry', data);
    }

    getPublicOptions(kind?: string): Observable<PartnerOption[]> {
        const kindParam = kind ? `&kind=${kind}` : '';
        return this.apiService.get<{ options: PartnerOption[] }>(`/partners/options/public?_=${Date.now()}${kindParam}`).pipe(
            map(res => res.options || [])
        );
    }
}
